module.exports = {"150824100":"海流图镇","150824101":"乌加河镇","150824102":"德岭山镇","150824103":"石哈河镇","150824104":"甘其毛都镇","150824105":"温更镇","150824200":"呼勒斯太苏木","150824201":"川井苏木","150824202":"巴音乌兰苏木","150824203":"新忽热苏木","150824400":"巴彦淖尔市牧洋海牧场有限公司","150824401":"巴彦淖尔市同和太种畜繁育中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150824.json
// module id = 551
// module chunks = 0